export function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    // JWT segments use unpadded base64url; atob expects padded base64.
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

/**
 * Firebase custom tokens are only valid for one hour after they are minted.
 * Treat a token as stale when it is within `marginSeconds` of expiring, or
 * when it cannot be decoded at all.
 */
export function isTokenNearExpiry(token, marginSeconds = 5 * 60) {
  const payload = token ? decodeJwtPayload(token) : null
  if (!payload || !payload.exp) {
    return true
  }
  return payload.exp * 1000 - Date.now() < marginSeconds * 1000
}
